import { type Action, TrackObject, useAnalyticsTracker } from ".";
import type { BaseAnalyticsExtras } from ".";
import type { FailedExtras } from ".";
export interface LoginExtras extends BaseAnalyticsExtras {
  externalAnonId?: string | null;
}

export type LoginEvent =
  | {
      action: Action.SUCCEEDED;
      extras: LoginExtras;
    }
  | {
      action: Action.FAILED;
      extras: FailedExtras;
    }
  | {
      action: Action.VIEWED;
      extras: LoginExtras;
    }
  | {
      action: Action.PRESSED;
      extras: LoginExtras;
    }
  | {
      action: Action.PENDING;
      extras: LoginExtras;
    };

export const useLoginAnalytics = () =>
  useAnalyticsTracker<LoginEvent>(TrackObject.LOGIN);
